export class Ownership {
    ID: string;
    NAME: string;
    DISPLAY_NAME: string;
    PERCENT: number;
    HOURS: number;
    REPLACEMENT_SALARY: number;
    ORDER: string;

    // Helpers
    selected: boolean = false;
    REPLACEMENT_SALARY_TEMP: number = 0;

    static parse(json: any): Ownership {
        if (json) {
            const os = new Ownership();
            os.ID = json.ID;
            os.NAME = json.NAME;
            os.DISPLAY_NAME = json.DISPLAY_NAME;
            os.PERCENT = json.PERCENT;
            os.HOURS = json.HOURS;
            os.REPLACEMENT_SALARY = json.REPLACEMENT_SALARY;
            os.ORDER = json.ORDER;

            return os;
        } else { return null; }
    }

    static parseArray(json: Array<any>): Array<Ownership> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Ownership.parse(j));

        return arr;
    }
}
